import { createFeatureSelector, createSelector } from "@ngrx/store";
import { CameraState } from "./camera.state";

export const selectCameraState = createFeatureSelector<CameraState>("camera");

export const selectCameraTarget = createSelector(
  selectCameraState,
  (state: CameraState) => state.target,
);

export const selectCameraZoomTarget = createSelector(
  selectCameraState,
  (state: CameraState) => state.zoom,
);


export const selectHistory = createSelector(
  selectCameraState,
  (state: CameraState) => state.history,
);

export const selectBooleans = createSelector(
  selectCameraState,
  (state: CameraState) => ({
    isTracking: state.isTracking,
    mapMode: state.mapMode,
  }),
);
